export class Opener {

  constructor(app) {
    
    var head,body;
    $('[data-role="opener-head"]').click((e)=>{
      head = $(e.currentTarget);
      body = head.next();
      head.toggleClass(CLASS_IS_ACTIVE);
      body.toggleClass(CLASS_IS_ACTIVE);
    });
  }

  // initTab(el) {
  //   let header = $(el);
  //   let link,href,content;
  //  
  //   try{
  //     header.find('a').each((i,el)=>{
  //       link = $(el);
  //       href = link.attr('href');
  //       content = $(href);
  //       if(link.hasClass(CLASS_IS_ACTIVE)){
  //         content.addClass(CLASS_IS_ACTIVE);
  //       }
  //       link.click(this.onClick.bind(this));
  //     });
  //    
  //   }catch(e){
  //     console.log(e);      
  //   }
  //  
  // }
  //
  // onClick(e){
  //   e.preventDefault();
  //
  //   let link,otherLinks,nav,href,content;
  //   link = $(e.currentTarget);
  //   nav = link.closest('[data-role="tabNav"]');
  //   otherLinks = nav.find('a').not(link);
  //   otherLinks.removeClass(CLASS_IS_ACTIVE);
  //   link.addClass(CLASS_IS_ACTIVE);
  //
  //   otherLinks.each((i,el)=>{
  //     content = $($(el).attr('href')).removeClass(CLASS_IS_ACTIVE);
  //   });
  //   $(link.attr('href')).addClass(CLASS_IS_ACTIVE);
  // }

}